module.exports = __webpack_public_path__ + "img/index-svg-white-en.fe4c20db.svg";